import { render, staticRenderFns } from "./AttachedFsModal.vue?vue&type=template&id=5b4774f6&scoped=true&"
import script from "./AttachedFsModal.vue?vue&type=script&lang=js&"
export * from "./AttachedFsModal.vue?vue&type=script&lang=js&"
import style0 from "./AttachedFsModal.vue?vue&type=style&index=0&id=5b4774f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4774f6",
  null
  
)

export default component.exports